import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryDamageDispatchCreateView from 'src/sections/stationery-damage-dispatch/view/stationery-damage-dispatch-create-view';

export default function StationeryDamageDispatchCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new stationery damage dispatch</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_STATIONERY_DAMAGE_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryDamageDispatchCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
